/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { IntervalContext } from '../contexts';

export const useIntervalStore = () => useContext(IntervalContext);
